// import * as ReactGA from "react-ga";
import ReactGA from "react-ga4";

export const initGA = (id) => {
  console.log(id);
  if (process.env.NODE_ENV === "development") {
    ReactGA.initialize(id);
  }
};
